<template>
    <div class="heading_product_extra">
        <div class="heading_product__icon heading_product__icon--sku">
            <img @click="show_product__sku" src="/single-product/product-sku.png" alt="product-sku-icon">
            <div class="heading_product__sku-modal">
                <div class="heading_product__sku-popup">
                    <h4>Product SKU</h4>
                    <div class="product_meta"><span class="sku">{{ sku?.meta_value }}</span></div>
                    <a @click="close_product__sku" class="sku-close-btn"><span class="sku-close-2">Close</span></a>
                </div>
            </div>
        </div>
        <div class="heading_product__icon heading_product__icon--share">
            <img src="/single-product/product-share.png" alt="share-icon">
            <div class="heading_product__share-popup">
                <a
                    v-for="(icon, index) in shareIcons"
                    :key="index"
                    :href="icon.shareUrl"
                    target="_blank"
                    class="share-buttons__share-button"
                    :class="'share-buttons__share-button--' + icon.name"

                >
                <img :src="icon.iconSrc" :alt="icon.altText" />
                </a>
            </div>
        </div>
    </div>
    <div class="bg_overlay"></div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_headingextra.scss";
</style>

<script setup lang="ts">
    const route = useRoute();
    const slug = route.params.slug as string;
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const props = defineProps(["data"]);
    const sku = computed(() => props.data);
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';
    const close_product__sku = () => {
        if (window.innerWidth <= 768) {
            const skuPopup = document.querySelector(".heading_product__sku-modal") as HTMLElement | null;
            // const skuPopup = document.querySelector(".heading_product__sku-popup") as HTMLElement | null;
            if (skuPopup) {
                skuPopup.style.display = "none";
            }
        }
    }

    const show_product__sku = () => {
        if (window.innerWidth <= 768) {
            const skuPopup = document.querySelector(".heading_product__sku-modal") as HTMLElement | null;
            if (skuPopup) {
                skuPopup.style.display = "flex";
            }
        }
    }
    const initClosePopup = () => {
        const bgOverlay = document.querySelector(".bg_overlay") as HTMLElement | null;

        if (bgOverlay) {
            bgOverlay.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const sharePopup = document.querySelector(".heading_product__share-popup") as HTMLElement | null;

                if (sharePopup) {
                    sharePopup.style.display = "none";
                    bgOverlay.style.display = "none";
                    document.body.classList.remove("no-scroll");
                }
            });
        }
    }

    onMounted(() => {
        initClosePopup()
    })
    const productUrl = computed(() => getLangUrl(`/product/${slug}`, baseUrl, locale.value));
    const cleanBaseUrl = computed(() => baseUrl.replace(/\/$/, '')); // Remove trailing slash
    
    const shareIcons = computed(() => [
        {
            name: 'facebook',
            iconSrc: '/single-product/icon-facebook.webp',
            altText: 'Facebook',
            shareUrl: `https://www.facebook.com/sharer.php?u=${cleanBaseUrl.value}${productUrl.value}`,
        },
        {
            name: 'instagram',
            iconSrc: '/single-product/icon-instagram.webp',
            altText: 'Instagram',
            shareUrl: 'https://www.instagram.com/skjewellery/'
        },
        {
            name: 'twitter',
            iconSrc: '/single-product/icon-twitter.webp',
            altText: 'Twitter',
            shareUrl: `https://twitter.com/intent/tweet?text=Product;url=${cleanBaseUrl.value}${productUrl.value}`
        },
        {
            name: 'whatsapp',
            iconSrc: '/single-product/whatsapp.webp',
            altText: 'Whatsapp',
            shareUrl: `https://api.whatsapp.com/send?text=${cleanBaseUrl.value}${productUrl.value}`
        },
        {
            name: 'telegram',
            iconSrc: '/single-product/icon-telegram.webp',
            altText: 'Telegram',
            shareUrl: `https://telegram.me/share/url?url=${cleanBaseUrl.value}${productUrl.value}`
        }
    ]);
</script>
